/**
 * Results Screen — Endrangliste nach Multiplayer-Spiel.
 */
import { div, h2, p, button, el } from '../../utils/domHelpers.js';
import { router } from '../../core/router.js';
import { lobbyService } from '../../services/lobbyService.js';
import { getRankBadge } from '../../utils/formatters.js';

export function renderResultsScreen() {
  const stored = sessionStorage.getItem('mpa:lastRanking');
  const ranking = stored ? JSON.parse(stored) : [];

  if (ranking.length === 0) {
    setTimeout(() => router.navigate('/'), 0);
    return div({}, ['Keine Ergebnisse — leite zurück...']);
  }

  const list = div({ class: 'ranking-list stagger' });

  for (const entry of ranking) {
    const classes = ['rank-row'];
    if (entry.rank === 1) classes.push('rank-row--first');
    if (entry.rank === 2) classes.push('rank-row--second');
    if (entry.rank === 3) classes.push('rank-row--third');

    list.appendChild(
      div({ class: classes.join(' ') }, [
        el('span', { class: 'rank-number' }, [getRankBadge(entry.rank)]),
        el('span', { class: 'rank-name' }, [entry.name]),
        el('span', { class: 'rank-score mono' }, [String(entry.score)]),
      ])
    );
  }

  const winner = ranking[0];

  return el('div', { class: 'glass-panel glass-panel--wide fade-up' }, [
    div({ class: 'text-center', style: { marginBottom: 'var(--sp-5)' } }, [
      h2({ class: 'glow-text-magenta' }, ['🏆 GAME OVER']),
      p({ class: 'mono', style: { marginTop: '8px' } }, [`Winner: ${winner.name}`]),
    ]),

    list,

    div({ class: 'flex-col gap-3', style: { marginTop: 'var(--sp-5)' } }, [
      button({
        class: 'btn btn-primary btn-block btn-lg pulse-glow',
        onclick: () => {
          // Wieder in der gleichen Lobby spielen — Host kann erneut starten
          if (lobbyService.currentLobby && lobbyService.isHost()) {
            lobbyService.startGame(5);
          } else {
            router.navigate('/lobby');
          }
        }
      }, ['🔁 Nochmal spielen']),
      button({
        class: 'btn btn-ghost btn-block',
        onclick: () => { lobbyService.leaveLobby(); router.navigate('/'); }
      }, ['← Zurück zum Menü']),
    ]),
  ]);
}
